<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()"(dataExportToExcel)="exportToExcel()"  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)" (resetData)="reset()" [showResetBtn]="showResetBtn"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no"[showSearch]="showSearch" [showExportBtn]="showExportBtn" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Ticket Category</div>
    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
  
      
        <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
                  (change)="onTicketChange($event.target.selectedIndex)">
            <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
          </select>
        </div>
        <div class="form-group" >
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="areaSelected"
                  (change)="onAreaChange($event.target.selectedIndex)">
            <option *ngFor="let area of areas" [value]="area.id">{{area.name}}</option>
          </select>
        </div>
        <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="parentSelected"
                  (change)="onParentChange($event.target.selectedIndex)">
            <option *ngFor="let parent of parents" [value]="parent.id">{{parent.name}}</option>
          </select>
        </div>
        <div class="form-group">
          <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="attrVal"
                  placeholder="Enter value">
          </div>
        </div>
        <div class="form-group">
          <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="attrDesc"
                  placeholder="Enter Description">
          </div>
        </div>
        <div class="form-group" *ngIf = "isShow">
          <mat-checkbox [(ngModel)]="attachClaimNo">Attach Claim No:</mat-checkbox>
        </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Search</div>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
                    (change)="onTicketChange($event.target.selectedIndex)">
                <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="icSelected">
                <option *ngFor="let ic of ics" [value]="ic.id">{{ic.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="levelSelected">
                <option *ngFor="let level of levels" [value]="level.id">{{level.name}}</option>
            </select>
        </div>
        <div class="form-group mar_top">
            <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Category Name "
                   [(ngModel)]="categoryName">
        </div>
    </div>
    <div class="modal-footer pad-8">
        <div class="form-group mar-bot-10" *ngIf="isSearch">
            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
        <button type="button" class="btn btn-primary radius-0" (click)="resetSearch()">Reset</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>

<notifier-container></notifier-container>

